export const parseCSV = (csvText: string): string[] =>
  csvText
    .split(/[\r\n]+/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0)

export const splitCSVLine = (line: string, delimiter: string): string[] => {
  const cells: string[] = []
  let current = ''
  let quoted = false

  for (let i = 0; i < line.length; i++) {
    const char = line[i]
    const next = line[i + 1]

    if (char === '"') {
      if (quoted && next === '"') {
        current += '"'
        i++
      } else quoted = !quoted
      continue
    }

    if (char === delimiter && !quoted) {
      cells.push(current.trim())
      current = ''
      continue
    }

    current += char
  }

  cells.push(current.trim())
  return cells
}
